import React, { useEffect, useState } from "react";
import { fetchStreak } from "@/lib/api";
import { Flame } from "lucide-react";

/**
 * A soft ribbon that appears on the Dashboard when the journaler has visited
 * three or more days in a row. Silent otherwise.
 */
export default function StreakRibbon() {
  const [s, setS] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        const r = await fetchStreak();
        setS(r);
      } catch (e) {
        console.error("streak fetch failed", e);
      }
    })();
  }, []);

  if (!s || !s.milestone) return null;

  return (
    <div
      className="inline-flex items-center gap-3 border border-terracotta/50 bg-terracotta/5 px-4 py-2 mb-8 animate-fade-up"
      data-testid="streak-ribbon"
    >
      <Flame className="h-4 w-4 text-terracotta" />
      <p className="font-sans uppercase tracking-[0.24em] text-[0.65rem] text-terracotta">
        {s.current_streak}-day streak
      </p>
      <span className="text-bone-500 text-xs">·</span>
      <p className="font-serif italic text-sm text-bone-200">
        {s.grace_recovered
          ? `A gentle day was forgiven. You have returned ${s.current_streak} days in a row.`
          : `You have returned ${s.current_streak} days in a row.`}
      </p>
    </div>
  );
}
